import { createSlice, current, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  interpreter: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  featuredInterpreters: [],
  current_page: 1,
  per_page: PAGELENGTH,
}

export const interpreterSlice = createSlice({
  name: 'interpreter',
  initialState: initialState,
  reducers: {
    setFeaturedInterpreters: (state, { payload }) => {
      state.featuredInterpreters = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setInterpreters: (state, { payload }) => {
      state.interpreter = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setMoreInterpreters: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    removeInterpreter: (state, { payload }) => {
      state.error = payload
    },
    clearAllInterpreter: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

export const addInterpreter = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.addInterpreter(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setInterpreter(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const updateInterpreter = (data, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateInterpreter(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setInterpreter(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeInterpreter = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeInterpreter(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setInterpreter(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const fetchInterpreters = (page, params, disableLoader, Aync) => async (dispatch) => {
  const apiService = new Api();
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchInterpreters(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setInterpreters(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setInterpreters(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
      
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }
    else{
      
        !disableLoader && dispatch(setLoader(false))
    }

  } catch (error) {
    console.log("error", error)
  }
}


export const changeStatus = (id, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.statusChange(id, data, "interpreters")
    if (json.status >= 200 && json.status < 300) {
      // console.log(json)
      // dispatch(setHospital(json.data))
      // callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      // callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const removeMultipleInterpreters = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeMultipleInterpreters(ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setHospital(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
};

export const fetchAvailableInterpreters = (params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchAvailableInterpreters(params)
    if (result.status >= 200 && result.status < 300) {
      dispatch(setFeaturedInterpreters(result.data));

    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader && dispatch(setLoader(false))

  dispatch(setLoader(false))
}

export const fetchInterpreterOptions = (page = 1, query = {}) => async (dispatch) => {
  try {
    const apiService = new Api();

    const params = {
      page,
      pageLength: query.pageLength || 10,
      sortBy: query.sortBy || "id",
      sortDirection: query.sortDirection || "asc",
      search: query.search || "",
    };

    const result = await Api.fetchInterpreters(page, params);

    if (result.status >= 200 && result.status < 300) {
      const data = result?.data?.data;

      return {
        options: data?.data?.map((i) => ({
          value: i.id,
          label: i.user.name || i.name || "Unknown",
        })) || [],
        hasMore: data?.current_page < data?.last_page,
        additional: {
          page: (data?.current_page || 1) + 1,
        },
      };
    }

    if (result?.status === 422) {
      return {
        options: [],
        hasMore: false,
        additional: { page: 1 },
      };
    }

    return {
      options: [],
      hasMore: false,
      additional: { page: 1 },
    };

  } catch (error) {
    console.error("fetchInterpreterOptions error:", error);
    return {
      options: [],
      hasMore: false,
      additional: { page: 1 },
    };
  }
};
export const fetchVendorInterpreterOptions = (page = 1, query = {}) => async (dispatch) => {
  try {
    const apiService = new Api();

    const params = {
      page,
      pageLength: query.pageLength || 10,
      sortBy: query.sortBy || "id",
      sortDirection: query.sortDirection || "asc",
      search: query.search || "",
    };

    const result = await Api.fetchVendorInterpreters(page, params);

    if (result.status >= 200 && result.status < 300) {
      const data = result?.data?.data;

     return {
  options: data?.data?.map((i) => ({
    value: i.id,
    label:
      (i.first_name && i.last_name)
        ? `${i.first_name} ${i.last_name}`
        : (i.first_name || i.last_name || i.name || "Unknown"),
  })) || [],
  hasMore: data?.current_page < data?.last_page,
  additional: {
    page: (data?.current_page || 1) + 1,
  },
};
    }

    if (result?.status === 422) {
      return {
        options: [],
        hasMore: false,
        additional: { page: 1 },
      };
    }

    return {
      options: [],
      hasMore: false,
      additional: { page: 1 },
    };

  } catch (error) {
    console.error("fetchInterpreterOptions error:", error);
    return {
      options: [],
      hasMore: false,
      additional: { page: 1 },
    };
  }
};

export const impersonateInterpreter = (id, callback) => async () => {
  try {
    const json = await Api.impersonateInterpreter(id);
    if (json?.status >= 200 && json?.status < 300) {
      callback(true, json.data.data);
    } else {
      callback(false, json?.data?.message || 'Failed to impersonate interpreter');
    }
  } catch (error) {
    callback(false, 'An error occurred');
  }
};

export const { setInterpreters, clearAllInterpreter, setLoader, setError, setMoreInterpreters, setFeaturedInterpreters } = interpreterSlice.actions


export default interpreterSlice.reducer
export const interpreterSelector = state => state.interpreter


